import React from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import { formatBytes } from '../../../helpers/formatBytes'
import { isImage } from '../../../helpers/isImage'

import DocumentIcon from '../../Icons/DocumentIcon'
import ImageIcon from '../../Icons/ImageIcon'
import TrashIcon from '../../Icons/TrashIcon'
import DownloadIcon from '../../Icons/DownloadIcon'

const FileItem = ({file, mode, onRemove}) => {
  const dateFormat = useSelector(state => state.company?.companyInfo?.date_format || 'DD.MM.YY')

  const extension = file.original_ext || file.name.split('.').pop().toLowerCase()

  const handleRemove = () => {
    onRemove(file.id)
  }

  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = file.url
    link.download = file.name || file.original_name
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className={styles.container}>
      <div className={styles.documentInfo}>
        {
          isImage(file.type || file.original_mime_type)
            ? <ImageIcon />
            : <DocumentIcon color="#0087FF" />
        }
        <div style={{flex: 1}}>
          <div className={styles.name}>{file.name || file.original_name}</div>
          <div className={styles.documentDetails}>
            <div>{extension}</div>
            <div className={styles.dot} />
            <div>{formatBytes(file.size)}</div>
            {
              file.created_at
                ? <>
                    <div className={styles.dot} />
                    <div>{moment(file.created_at).format(dateFormat.replaceAll('.', '-').replace('YY', 'YYYY'))}</div>
                  </>
                : null
            }
            
          </div>
        </div>
        {
          file.url
            ? <div className={styles.downloadButton} onClick={handleDownload}>
                <DownloadIcon />
              </div>
            : null
        }
        
        {
          mode === 'edit'
            ? <div className={styles.removeButton} onClick={handleRemove}>
                <TrashIcon />
              </div>
            : null
        }
      </div>
    </div>
  )
}

export default FileItem
